export function sortSuppliersByName(suppliers) {
  return [...(suppliers || [])].sort((a, b) => {
    const nameA = typeof a === "object" ? a?.name ?? String(a?.id ?? "") : String(a);
    const nameB = typeof b === "object" ? b?.name ?? String(b?.id ?? "") : String(b);
    return String(nameA).localeCompare(String(nameB));
  });
}
